import {ROUTES, ROLES} from 'common/constants';


export const USER_ROLES = ROLES;

// Mirrors the backend (unifon-ksportal-backend controllers/index.go): BMO endpoints use RequireBmo,
// 360 and MRC endpoints use RequireCustomerService. Keep these in sync, or users get pages whose
// requests all fail with 403.
export const USER_ACCESS = {
	MRC:          [ROLES.CUSTOMER_SERVICE],
	PROFILE:      [ROLES.ADMIN, ROLES.CUSTOMER_SERVICE, ROLES.LARGEACC, ROLES.BMO],
	BMODASHBOARD: [ROLES.BMO],
	THREE_SIXTY:  [ROLES.CUSTOMER_SERVICE],
};

// Readable role names for the Unauthorized page (translated there)
export const ROLE_LABELS: Record<string, string> = {
	[ROLES.ADMIN]:            'Admin',
	[ROLES.BMO]:              'BMO',
	[ROLES.LARGEACC]:         'Large account',
	[ROLES.CUSTOMER_SERVICE]: 'Customer service',
	[ROLES.MRC]:              'MRC',
	[ROLES.KS_USER]:          'KS user',
	[ROLES.KS_ADMIN]:         'KS admin',
};

export const ROOT_ROUTES_REDIRECT = [
	ROUTES.MRC,
	ROUTES.PROFILE,
	ROUTES.BMODASHBOARD,
	ROUTES.THREE_SIXTY,
];

// First path segment, lower-cased: '/BMO/create_ticket' -> 'bmo'. React Router matches paths
// case-insensitively, so access checks must too.
export const getRouteSection = (path: string): string => (path.split('/')[1] ?? '').toLowerCase();

// The protected root route that `path` belongs to, e.g. '/bmo/create_ticket' -> ROUTES.BMODASHBOARD
export const findRootRoute = (path: string): string | undefined =>
	ROOT_ROUTES_REDIRECT.find((route) => getRouteSection(route) === getRouteSection(path));

export const ROUTES_USER_ACCESS_MAPPING = {
	[ROUTES.MRC]:          [USER_ACCESS.MRC],
	[ROUTES.PROFILE]:      [USER_ACCESS.PROFILE],
	[ROUTES.BMODASHBOARD]: [USER_ACCESS.BMODASHBOARD],
	[ROUTES.THREE_SIXTY]:  [USER_ACCESS.THREE_SIXTY],
};
